import React from 'react'
import { View, ImageStyle, Image, ViewStyle, TextStyle } from 'react-native'
import { color } from '../../theme'
import { Text } from '../text'
import { AvatarProps } from './avatar.props'
import { SvgIcon } from '../svg-icon'
import { iconAdmin, iconProfile } from '../../assets'

const SMALL12: ImageStyle | ViewStyle = {
  height: 18,
  width: 18,
  borderRadius: 17,
}

const SMALL24: ImageStyle | ViewStyle = {
  height: 24,
  width: 24,
  borderRadius: 64,
}
const SMALL: ImageStyle | ViewStyle = {
  height: 32,
  width: 32,
  borderRadius: 64,
}
const SMALL40: ImageStyle | ViewStyle = {
  height: 40,
  width: 40,
  borderRadius: 100,
}
const MEDIUM: ImageStyle | ViewStyle = {
  height: 52,
  width: 52,
  borderRadius: 100,
}
const MEDIUM60: ImageStyle | ViewStyle = {
  height: 60,
  width: 60,
  borderRadius: 100,
}
const LARGE: ImageStyle | ViewStyle = {
  height: 100,
  width: 100,
  borderRadius: 100,
}

export const DefaultAvatar = (props: any) => {
  const { name, size, customSize, style } = props
  let initials = ''

  const splitName = name ? name.split(' ') : ''
  if (splitName.length === 1) {
    initials = splitName[0].substring(0, 1).toUpperCase()
  } else if (splitName.length > 1) {
    initials += splitName[0].substring(0, 1).toUpperCase()
    initials += splitName[1].substring(0, 1).toUpperCase()
  } else {
    initials = '?'
  }

  const styled: ViewStyle = {
    backgroundColor: color.blue,
    ...style,
  }

  const fontSize = customSize
    ? 16
    : size === 'small12'
      ? 11
      : size === 'small24'
        ? 12
        : size === 'small'
          ? 13
          : size === 'small40'
            ? 16
            : size === 'medium'
              ? 20
              : size === 'medium60'
                ? 28
                : 48

  const textStyle: TextStyle = {
    fontFamily: 'Inter-Bold',
    color: color.white,
    // eslint-disable-next-line
    fontSize,
  }

  return (
    <View style={{ ...styled, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Text variant="titleMedium" style={textStyle} text={initials} />
      {/* <SvgIcon
        size={size === 'small24' ? 12 : size === 'small' ? 20 : size === 'medium' ? 32 : 24}
        src={iconProfile}
        color="#fff"
      /> */}
    </View>
  )
}

/**
 * Stateless functional component for your needs
 *
 * Component description here for TypeScript tips.
 */
export function Avatar(props: AvatarProps) {
  const { style, size, source, name, customSize, ...rest } = props
  let styled

  if (customSize) {
    styled = {
      height: customSize,
      width: customSize,
      borderRadius: customSize,
    }
  } else {
    switch (size) {
      case 'small12':
        styled = SMALL12
        break
      case 'small24':
        styled = SMALL24
        break
      case 'small':
        styled = SMALL
        break
      case 'small40':
        styled = SMALL40
        break
      case 'medium':
        styled = MEDIUM
        break
      case 'medium60':
        styled = MEDIUM60
        break
      case 'large':
        styled = LARGE
        break
      default:
        styled = MEDIUM
    }
  }

  return (
    <View style={style} {...rest}>
      {source ? (
        <Image source={{ uri: source }} style={styled as ImageStyle} />
      ) : (
        <DefaultAvatar
          customSize={customSize}
          size={size}
          style={styled as ViewStyle}
          name={name}
        />
      )}
    </View>
  )
}
